import type { ImageProps } from '@/components/Image';
import type { Content } from '@/types/content';

export const mapLabradorImageToStandaloneImage = (labradorImage: Content): ImageProps => {
  const { data, meta } = labradorImage ?? {};
  const { imageUrl } = data ?? {};

  const src = imageUrl?.[meta?.device] || imageUrl?.desktop || imageUrl?.mobile;

  return {
    src,
    isGif: data?.isGif,
    alt: data?.alt,
    caption: data?.showCaption && data?.caption,
    byline: data?.byline,
    link: {
      href: data?.url,
      target: data?.linkTarget,
      options: {
        rel: data?.rel,
      },
    },
  };
};
